import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Requests Vehicle Groups to be unassigned from a specific Map Set
 * @param id The ID of the Map Set who is being unassigned from
 * @param vehicleGroupIds The IDs of the Vehicle Groups being unassigned
 * @returns Data object containing array of unassigned Vehicle Group's IDs
 */
export function postMapSetsVehicleGroupsUnassign(
  this: unknown,
  id: number,
  vehicleGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).mapSetsVehicleGroupsUnassignUrl(id),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(vehicleGroupIds),
        }
      )
    )
  ).pipe(selectData(fleetMessageSchema.extend({ data: z.array(z.number()) })));
}
